import { z } from 'zod';
import { c } from '../../contract';

export const translationsRouter = c.router(
  {
    getTranslations: {
      summary: 'Get translations for galatea',
      method: 'GET',
      path: '/',
      query: z.object({
        keys: z.string().transform((keys) => keys.split(',')),
        locale: z.string(),
      }),
      responses: {
        200: z.record(z.string(), z.string()),
      },
    },
  },
  { pathPrefix: '/translations' },
);
